export default __webpack_public_path__ + "static/media/StitchingWire.d8dcd9a8.png";